import React from "react";

import { BreakpointProvider } from "@utils/breakpoints/breakpoints.provider";
import { attemptMethod } from "@utils/general";

import EnergyLabelComponent from "./energyLabel.component";

type Props = {
    energyLabel: string;
    energyLabelLarge: string;
    energyLabelSize: string;
    oneByTwo: boolean;
    energyLabelAltText: string;
};

const EnergyLabelContainer = ({
    energyLabel,
    energyLabelLarge,
    energyLabelSize,
    oneByTwo,
    energyLabelAltText,
}: Props) => {
    if (!energyLabel) {
        return null;
    }

    const energyLabelLargeJson = attemptMethod(
        () => JSON.parse(energyLabelLarge),
        undefined,
    );

    return (
        <BreakpointProvider>
            <EnergyLabelComponent
                energyLabel={energyLabel}
                energyLabelLarge={energyLabelLargeJson}
                energyLabelSize={energyLabelSize}
                oneByTwo={oneByTwo}
                energyLabelAltText={energyLabelAltText}
            />
        </BreakpointProvider>
    );
};

export { EnergyLabelContainer };
